import { GoogleDocLegalPage } from './legal/GoogleDocLegalPage';
import { LEGAL_DOCUMENTS } from './legal/legalDocuments';

export const EULA = () => <GoogleDocLegalPage document={LEGAL_DOCUMENTS.eula} />;
